const wowApp = require('angular').module('wowApp.common');

wowApp.filter('wowCurrency', ['currencyFilter', require('./wow-currency')]);
wowApp.filter('wowCurrencyFull', ['wowCurrencyFilter', require('./wow-currencyfull')]);
wowApp.filter('wowCurrencyCents', ['wowCurrencyFilter', require('./wow-currency-cents')]);
wowApp.filter('sanitize', ['$sce', require('./wow-sanitize')]);
wowApp.filter('hyphenate', [require('./wow-hyphenate-name')]);
wowApp.filter('usernamelimiter', [require('./wow-username-limiter')]);
wowApp.filter('wowLoyaltyPoints', ['Settings', require('./wow-loyalty-points')]);
wowApp.filter('wowTrim', [require('./wow-trim')]);



// WEBPACK FOOTER //
// ./src/common/filters/index.js